module.exports = __webpack_public_path__ + "static/media/Faculty_Poster_v5.9eef6e1b.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/informatics/Faculty_Poster_v5.pdf
// module id = 406
// module chunks = 0